module.exports = __webpack_public_path__ + "img/banner-principal.de1d4527.png";